<!--
 * @FileDescription: 售后订单列表-Web
 * @Author: 陈文景
 * @Date: 2022-11-08 15:23:21
 * @LastEditors: 最后更新作者
 * @LastEditTime: 最后更新时间
-->
<template>
  <div class="container">
    <h3 class="title">{{ $t('Order.Sales.Web.Index.RefundingOrder') }}</h3>

    <div class="list">
      <div class="header">
        <el-select v-model="parameter.paymentMethod" clearable size="medium" :placeholder="$t('Order.Sales.Web.Index.PaymentMethod')" class="payment-method-select" @change="getAfterSalesOrderList">
          <el-option v-for="item in paymentMethodOptions" :key="item.value" :label="item.label" :value="item.value" />
        </el-select>

        <el-select v-model="parameter.status" size="medium" multiple collapse-tags filterable clearable :placeholder="$t('Order.Sales.Web.Index.State')" class="status-select" @change="onSelectStatus">
          <el-option :label="$t('Order.Sales.Web.Index.Processing')" :value="1" />
          <el-option :label="$t('Order.Sales.Web.Index.Refunding')" :value="2" />
          <el-option :label="$t('Order.Sales.Web.Index.Rejected')" :value="3" />
          <el-option :label="$t('Order.Sales.Web.Index.Completed')" :value="4" />
        </el-select>

        <el-date-picker v-model="parameter.dateTime" :clearable="false" type="datetimerange" size="medium" range-separator="~" placement="bottom-start" :default-time="['00:00:00', '23:59:59']" value-format="timestamp" :start-placeholder="$t('Order.Sales.Web.Index.StartDate')" :end-placeholder="$t('Order.Sales.Web.Index.EndDate')" class="el-date-picker" @change="changeDatePicker" />

        <BatchSearch :placeholder="$t('Order.Sales.Web.Index.SearchingFor')" :option="searchOptins" :selected="parameter.searchType" @select="selectSearchType" @search="handleSearch" @clear="clearSearchValue" />
      </div>

      <el-table :data="orders" v-loading="loading" style="width: 100%">
        <el-table-column :label="$t('Order.Sales.Web.Index.IusseID')" width="150">
          <template v-slot="{ row }">
            <span class="review-id" @click="() => handleReviewId(row.returnsId)">{{ row.returnsId }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('Order.Sales.Web.Index.OrderID')" width="150">
          <template v-slot="{ row }">
            <span class="order-id">{{ defaultTips(row.kkOrderId) }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('Order.Sales.Web.Index.RefundAmount')">
          <template v-slot="{ row }">
            <p class="refund-money">{{ defaultTips(row.refundAmount) }}</p>
            <p class="refund-remarks">{{ defaultTips(row.refundReason) }}</p>
          </template>
        </el-table-column>
        <el-table-column :label="$t('Order.Sales.Web.Index.CreationTime')" width="150">
          <template v-slot="{ row }">
            <span class="creation-time">{{ formatTimeStamp(row.createDate) }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('Order.Sales.Web.Index.Type')" width="150">
          <template v-slot="{ row }">
            <span class="type">{{ refundType(row.type) }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('Order.Sales.Web.Index.State')" width="150">
          <template v-slot="{ row }">
            <span class="state">{{ ordersStatus(row.status) }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('Order.Sales.Web.Index.PaymentMethod')" width="150">
          <template v-slot="{ row }">
            <span class="payment-method">{{ paymentMethod(row.paymentMethod) }}</span>
          </template>
        </el-table-column>

        <div slot="empty" class="not-data">
          <img src="~@/assets/img/undraw_random_thoughts_re_cob6.svg" alt="img.svg" />
          <div class="tips-text">{{ $t('Order.Sales.Web.Index.NoRecord') }}</div>
        </div>
      </el-table>

      <div v-if="total >= 20" class="footer">
        <el-pagination :page-sizes="[20, 30, 40, 50]" layout="total, sizes, prev, pager, next, jumper" :total="total" @size-change="sizeChange" @current-change="currentChange" />
      </div>
    </div>
  </div>
</template>

<script>
import API from '@/api'
import cloneDeep from 'lodash/cloneDeep'
import BatchSearch from './components/BatchSearch.vue'
import { formatTimeStamp } from '@/util/moment'

export default {
  components: {
    BatchSearch
  },
  data() {
    return {
      formatTimeStamp,

      parameter: {
        searchArray: [], // 搜索关键字数组
        searchType: 0, // 搜索类型：0.Iusse ID 1.Order ID
        dateTime: [Date.now() - 29 * 24 * 3600000, Date.now()], // 时间日期(请求前需要删除该字段)
        timeAt: Date.now() - 29 * 24 * 3600000, // 开始时间
        timeTo: Date.now(), // 结束时间
        paymentMethod: undefined, // 付款方式：0.余额 1.信用卡 2.Paypal
        status: [], // 0.待处理 1.审核中 2.处理中 3.已拒绝 4.已完成
        pageSize: 20,
        pageNumber: 1
      },
      status: undefined,

      // 支付方式下拉选项
      paymentMethodOptions: [
        { label: 'Balance', value: 0 },
        { label: 'Credit Card', value: 1 },
        { label: 'Paypal', value: 2 },
        { label: 'Airwallex', value: 3 },
        { label: 'Payoneer', value: 9 }
      ],

      // 搜索条件
      searchOptins: [
        { label: 'Iusse ID', value: 1 },
        { label: 'Order ID', value: 0 }
      ],

      orders: [
        // {
        //   id: 1,
        //   returnsId: '202110132055832',
        //   kkOrderId: '202110132055832',
        //   refundAmount: '$52.00',
        //   refundReason: 'This item has not been shipped and is no longer needed',
        //   createDate: 1670750871000,
        //   type: 0,
        //   status: 0,
        //   paymentMethod: 0
        // },
        // {
        //   id: 2,
        //   returnsId: '202110132055888',
        //   kkOrderId: '202110132055832',
        //   refundAmount: '$52.00',
        //   refundReason: 'This item has not been shipped and is no longer needed',
        //   createDate: 1670750871000,
        //   type: 0,
        //   status: 0,
        //   paymentMethod: 0
        // }
      ],
      total: 0,
      loading: false
    }
  },
  computed: {
    refundType() {
      return (value) => {
        value = Number.parseInt(value)
        switch (value) {
          case 0:
            return 'Refund'
          case 1:
            return 'Compensate'
          default:
            return '-'
        }
      }
    },
    paymentMethod() {
      return (value) => {
        value = Number.parseInt(value)
        switch (value) {
          case 0:
            return 'Balance'
          case 1:
            return 'Credit Card'
          case 2:
            return 'Paypal'
          case 3:
            return 'Airwallex'
          case 9:
            return 'Payoneer'
          default:
            return '-'
        }
      }
    },
    ordersStatus() {
      return (value) => {
        value = Number.parseInt(value)
        switch (value) {
          case 0:
            return 'Processing' // 处理中
          case 1:
            return 'Processing' // 审核中
          case 2:
            return 'Refunding' // 退款中
          case 3:
            return 'Rejected' // 已拒绝
          case 4:
            return 'Completed' // 已完成
          default:
            return '-'
        }
      }
    },
    defaultTips() {
      return (value) => value || '-'
    }
  },
  created() {
    this.getAfterSalesOrderList()
  },
  methods: {
    /**
     * API 获取售后订单列表
     *
     * @param {Boolean} reset 是否重置分页
     */
    async getAfterSalesOrderList(reset = true) {
      try {
        if (reset) {
          this.parameter.pageNumber = 1
        }
        this.loading = true
        let query = cloneDeep(this.parameter)
        delete query.dateTime
        if (this.status === 0) {
          query.status.push(this.status)
        } else {
          query.status = query.status.filter((item) => item !== 0)
        }
        let { data } = await API.getAfterSalesOrderList(query)
        this.total = data.total
        this.orders = data.list
        this.loading = false
      } catch (error) {
        this.loading = false
      }
    },

    /**
     * 选择状态的回调事件
     *
     * @param {Array} value 当前选中的值
     */
    onSelectStatus(value) {
      if (value.some((item) => item === 1)) {
        this.status = 0
      } else {
        this.status = undefined
      }
      this.getAfterSalesOrderList()
    },

    /**
     * 日期选择器的回调事件
     *
     * @param {Array} date 选中的时间数组
     */
    changeDatePicker(date) {
      if (date && date.length === 2) {
        this.parameter.timeAt = date[0]
        this.parameter.timeTo = date[1]
      } else {
        this.parameter.timeAt = undefined
        this.parameter.timeTo = undefined
      }
      this.getAfterSalesOrderList()
    },

    /**
     * 选择搜索类型的回调
     *
     * @param {String} value 当前选中的值
     */
    selectSearchType(value) {
      this.parameter.searchType = value
      if (this.parameter.searchArray.length) {
        this.getAfterSalesOrderList()
      }
    },

    /**
     * 搜索按钮触发的回调
     *
     * @param {String} value
     */
    handleSearch(value) {
      if (value) {
        this.parameter.searchArray = value.split(',')
        this.getAfterSalesOrderList()
      }
    },

    /**
     * 批量搜索框的清除事件的回调
     */
    clearSearchValue() {
      this.parameter.searchArray = []
      this.getAfterSalesOrderList()
    },

    /**
     * 某个售后ID被点击的回调事件
     *
     * @param {Number} returnsId 当前行的售后ID
     */
    handleReviewId(returnsId) {
      this.$router.push(`/order/after-sales-order?returnsId=${returnsId}`)
    },

    /**
     * 每页显示数量发生改变时的回调
     *
     * @param size 每页显示数量
     */
    sizeChange(size) {
      this.parameter.pageSize = size
      this.getAfterSalesOrderList(false)
    },

    /**
     * 上一页/下一页/当前页发生改变时的回调
     *
     * @param current 当前页
     */
    currentChange(current) {
      this.parameter.pageNumber = current
      this.getAfterSalesOrderList(false)
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  width: 1228px;
  margin: 0 auto;
  .title {
    font-size: 18px;
    margin: 8px 0;
  }
  .list {
    width: 100%;
    padding: 20px;
    background-color: #fff;
    .header {
      margin-bottom: 20px;
      .payment-method-select {
        width: 168px;
      }
      .status-select {
        width: 200px;
        margin-left: 15px;
      }
      /deep/.el-range-input {
        width: 45%;
      }
      /deep/.el-input__inner {
        border-radius: 2px;
      }
      /deep/.el-range__close-icon {
        display: none;
      }
      .el-date-picker {
        width: 358px;
        margin-left: 15px;
        border-radius: 2px;
      }
    }

    .not-data {
      padding: 20px 0;
      img {
        width: 328px;
        object-fit: cover;
      }
      .tips-text {
        color: #747a87;
        font-size: 14px;
        line-height: 32px;
      }
    }

    .review-id,
    .order-id,
    .refund-remarks,
    .creation-time,
    .type,
    .state,
    .refund-money,
    .payment-method {
      color: #747a87;
      font-size: 12px;
    }

    .review-id {
      color: #99c41c;
      user-select: none;
      cursor: pointer;
    }

    .refund-money {
      color: #eb5757;
    }

    /deep/.el-input-group__append {
      background: rgba(153, 196, 28, 0.2);
      .el-icon-search {
        color: #99c41c;
      }
    }

    /deep/.el-table th.el-table__cell {
      color: #10141d;
      background-color: rgba(0, 0, 0, 0.02);
    }
  }
  .footer {
    text-align: end;
    margin-top: 15px;
  }
}
</style>
